/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Col, Form, Row, Alert, Tab, Tabs } from 'react-bootstrap';
import { FormattedDate, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import DateSelector from '../../components/DateSelector';
import { getPreviousMonth, localHour, utcHour, IMonthValue, formatDateYYYYMM } from '../../util/DateUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WaitModal, ConfirmModal, ReadyModal } from '../../components/ReportModals';
import * as numerusAPI from '../../api/NumerusData';

const DECIMALS = 3;

interface IManageRecyclingFeeReportsProps {
  intl: any;
}

const ManageRecyclingFeeReports = (props: IManageRecyclingFeeReportsProps) => {
  const [,setState] = useState({}); // just to force re-render when upload status changes
  const [tab, setTab] = useState("reports");
  const [startDate, setStartDate] = useState(getPreviousMonth());
  const [endDate, setEndDate] = useState(getPreviousMonth());
  const [reportData, setReportData] = useState([] as numerusAPI.IRecyclingFeeReport[]);
  const [scheduleData, setScheduleData] = useState({} as numerusAPI.IRecyclingFeeReportSchedule);
  const [date, setDate] = useState(getPreviousMonth());
  const [modalWaitOpen, setWaitModalOpen] = useState(false);
  const [modalSaveOpen, setSaveModalOpen] = useState(false);
  const [modalConfOpen, setConfirmationModalOpen] = useState(false);
  const [modalReadyOpen, setReadyModalOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [infoTextKey, setInfoTextKey] = useState('');
  const [infoTextMoreKey, setInfoTextMoreKey] = useState('');
  const [diffTotalValFi, setDiffTotalValFi] = useState('');
  const [diffTotalValAl, setDiffTotalValAl] = useState('');
  const [diffTotalPomFi, setDiffTotalPomFi] = useState('');
  const [diffTotalPomAl, setDiffTotalPomAl] = useState('');
  const [showReportsAlert, setShowReportsAlert] = useState(false);
  const [alertTextKey, setAlertTextKey] = useState('');
  const [hideData, setHideData] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [savedAlready, setSavedAlready] = useState(false);
  const [numerusData, setNumerusData] = useState({} as numerusAPI.INumerusData);

  useEffect(() => {
    numerusAPI.getRecyclingFeeSchedule().then((data: any) => {
      if (data) {
        setScheduleData(data as numerusAPI.IRecyclingFeeReportSchedule);
      }
    });
  }, []);

  const getDayList = () => {
    const dayList: JSX.Element[] = [];
    dayList.push(<option value="" key="day-0">{props.intl.formatMessage({id:'day-list.choose'})}</option>);
    for(let i = 0; i<31; i++) {
      // eslint-disable-next-line eqeqeq
      dayList.push(<option key={"day-"+i+1} value={i+1}>{i+1}{props.intl.formatMessage({id:'day-list.day'})}</option>);
    }
    return dayList;
  }

  const getTimeList = () => {
    const timeList: JSX.Element[] = [];
    timeList.push(<option value="" key="time-0">{props.intl.formatMessage({id:'time-list.choose'})}</option>);
    for(let i = 0; i<24; i++) {
      // eslint-disable-next-line eqeqeq
      timeList.push(<option key={"time-"+i+1} value={i}>{ (i).toLocaleString('fi-FI', {minimumIntegerDigits: 2, useGrouping:false}) }:00</option>);
    }
    return timeList;
  }

  const clear = () => {
    console.log("clearing...")
    setWaitModalOpen(false);
    setHideData(true);
    setNumerusData({} as numerusAPI.INumerusData);
    setSavedAlready(false);
    setState({});
    setSaveDisable(true);
    setShowAlert(false);
    setShowInfo(false);
    setDiffTotalValFi('');
    setDiffTotalValAl('');
    setDiffTotalPomFi('');
    setDiffTotalPomAl('');
  }

  const fetchReports = () => {
    setShowReportsAlert(false)
    setWaitModalOpen(true);
    numerusAPI.getRecyclingFeeReports(formatDateYYYYMM(startDate), formatDateYYYYMM(endDate))
      .then((data) => {
        console.log("data", data);
        setReportData(data);
        setWaitModalOpen(false);
        if (!data || data.length === 0) {
          setShowReportsAlert(true);
        }
      });
  }

  const getReportsDataTable = () => {
    const rows: { }[] = [];
    if (reportData && Array.isArray(reportData)) {
      reportData.forEach((row: numerusAPI.IRecyclingFeeReport, index) => {
        let fi_fee = parseFloat(row.total_fi_recycling_fee);
        let fi_pom = parseFloat(row.total_fi_pom_weight);
        let al_fee = parseFloat(row.total_al_recycling_fee);
        let al_pom = parseFloat(row.total_al_pom_weight);

        rows.push(
          <tr key={index}>
            <td>
              <FormattedDate
                  value={new Date(row.report_period)}
                  month="long"
                  year="numeric"
                />
            </td>
            <td className="right"><FormattedNumber value={fi_fee} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/></td>
            <td className="right"><FormattedNumber value={al_fee} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/></td>
            <td className="right"><FormattedNumber value={fi_pom} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/></td>
            <td className="right"><FormattedNumber value={al_pom} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/></td>
          </tr>
        );
      });
      if(rows.length > 0) return rows;
    }
  }

  const getNumerusResultDataTable = () => {
    return (
    <div className="generalReportImportResult" hidden={hideData}>
      <div className="d-flex flex-md-row flex-column-reverse">
        <div className="reportResultHeader">
          <h3 className="monthRange">
            <FormattedDate  value={new Date(date.year, date.month)}
                            month="long" year="numeric" />
          </h3>
          <h3 className="reportHeader">
            <FormattedMessage id="recyclingfeereports.numerus.data"/>
          </h3>
        </div>
      </div>

      <div className="handlerReportSummary">
        <pre><code> { JSON.stringify(numerusData, null, "\t") }</code></pre>
      </div>
    </div>);
  }

  const checkIsDataChanged = (numData: numerusAPI.INumerusData, data: any) => {

    let diffFeeFi = numData.totals.fi.val - data.result.total_fi_recycling_fee;
    let diffFeeAl = numData.totals.al.val - data.result.total_al_recycling_fee;
    let diffWeightFi = numData.totals.fi.kg - data.result.total_fi_pom_weight;
    let diffWeightAl = numData.totals.al.kg - data.result.total_al_pom_weight;

    setInfoTextKey('recyclingfeereports.numerus.manual.info.exists');
    if (diffFeeFi || diffFeeAl || diffWeightFi || diffWeightAl) {
      setInfoTextMoreKey('recyclingfeereports.numerus.manual.info.data.diff');
      let diffFeeFiText = diffFeeFi ? "Total VAL FI: " + data.result.total_fi_recycling_fee + " -> " + numData.totals.fi.val : "";
      let diffFeeAlText = diffFeeAl ? "Total VAL AL: " + data.result.total_al_recycling_fee + " -> " + numData.totals.al.val : "";
      let diffWeightFiText = diffWeightFi ? "Total POM FI: " + data.result.total_fi_pom_weight + " -> " + numData.totals.fi.kg : "";
      let diffWeightAlText = diffWeightAl ? "Total POM AL: " + data.result.total_al_pom_weight + " -> " + numData.totals.al.kg : "";
      setDiffTotalValFi(diffFeeFiText);
      setDiffTotalValAl(diffFeeAlText);
      setDiffTotalPomFi(diffWeightFiText);
      setDiffTotalPomAl(diffWeightAlText);
    }
    else {
      setInfoTextMoreKey('recyclingfeereports.numerus.manual.info.data.same');
    }
    setShowInfo(true);
  }

  const fetchNumerusData = () => {
    let tempNumerusData = {} as numerusAPI.INumerusData;
    setWaitModalOpen(true);
    numerusAPI.getNumerusData(
      {
        from: date.month + 1, // monthIndex to actual month
        to: date.month + 1,
        year: date.year
      }
    ).then((data: any) => {
      setNumerusData(data);
      tempNumerusData = data;
      if (!data || data.error) {
        setAlertTextKey('recyclingfeereports.numerus.fetch.error');
        setSaveDisable(true);
        setShowAlert(true);
        return Promise.reject("No data");
      } else if (data.totals && !data.totals.fi.val) {
        setAlertTextKey('recyclingfeereports.numerus.fetch.empty');
        setHideData(false);
        setSaveDisable(true);
        setShowAlert(true);
      }
      else {
        setSaveDisable(false);
        setShowAlert(false);
      }
    }).then(() => {
      return numerusAPI.getSavedNumerusData(date)
    }).then((data: any) => {
      console.log("Saved numerus data in db: ", data);
      let dataPresent = ( data.result && data.result.total_fi_recycling_fee > 0 ) ? true : false;
      setSavedAlready(dataPresent);
      if (dataPresent) {
        checkIsDataChanged(tempNumerusData, data);
      }
      setHideData(false);
    }).catch((result: any) => {
      console.log("Error: ", result);
    }).finally(() => {
      setState({});
      setWaitModalOpen(false);
    });
  }

  const saveNumerusDataToDB = () => {

    setSaveModalOpen(true);
    numerusAPI.saveNumerusData(date, numerusData)
    .then((data: any) => {
      console.log("Save result: ", data);
      if (!data || data.error) {
        setAlertTextKey('recyclingfeereports.numerus.save.error');
        setShowAlert(true);
      } else {
        setReadyModalOpen(true);
        setTimeout(() => setReadyModalOpen(false), 2000);
        setShowAlert(false);
      }
    }).finally(() => {
      setState({});
      setSaveModalOpen(false);
    });
  }

  return (
    <div>
      <WaitModal
        messageId="recyclingfeereports.numerus.fetching"
        modalOpen={modalWaitOpen}
        setModalOpen={(open: boolean) => setWaitModalOpen(open)}
      />
      <WaitModal
        messageId='recyclingfeereports.numerus.saving'
        modalOpen={modalSaveOpen}
        setModalOpen={(open: boolean) => setSaveModalOpen(open)}/>
      <ConfirmModal
        modalOpen={modalConfOpen}
        labelId={'recyclingfeereports.numerus.exists'}
        messageId={'recyclingfeereports.numerus.exists.text'}
        modalText={''}
        submitId={'recyclingfeereports.numerus.save'} dismissId={'recyclingfeereports.numerus.cancel'}
        onDismiss={() => { setConfirmationModalOpen(false); } }
        onSubmit={() => { setConfirmationModalOpen(false); saveNumerusDataToDB(); } } />
      <ReadyModal
        messageId="recyclingfeereports.numerus.save.ready"
        modalOpen={modalReadyOpen}
        setModalOpen={(open: boolean) => setReadyModalOpen(open)}
      />
      <h1>
        <FormattedMessage id="recyclingfeereports.header"/> -
        <FormattedMessage id="recyclingfeereports.manage"/>
      </h1>

      <div className="settings">
        <Tabs defaultActiveKey={tab} id="recyclingfeereports-manage-tabs" onSelect={(eventKey : string) => setTab(eventKey)}>
          <Tab eventKey="reports" title={props.intl.formatMessage({id:'recyclingfeereports.numerus.reports'})}>

            <div className="d-flex flex-row row">

              <div className="col-md-12 flex-row">
                <div className="form-group">
                  <label><FormattedMessage id="recyclingfeereports.numerus.browse.monthrange"/></label>
                  <div className="d-flex flex-row row">
                    <div className="col-md-6 datepicker-input">
                      <DateSelector startPeriod={startDate} endPeriod={endDate}
                                    onChange={(start: IMonthValue, end: IMonthValue) => { setStartDate(start); setEndDate(end); } } 
                                    dateFormat={'yyyy-MM'} isStartAndEnd={true}/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-buttons d-flex flex-row col">
                <button className="btn btn-primary send-button btn-search ml-auto"
                        onClick={() => fetchReports()}
                        aria-label="fetch reports">
                  <FormattedMessage id="recyclingfeereports.numerus.fetch"/>
                </button>
              </div>
            </div>

            {reportData && Array.isArray(reportData) && reportData.length > 0 &&
            <div className="table-responsive search-results">
              <table className="table table-sm table-striped">
                <thead className="reportDataHeader table table-bordered table-sm">
                  <tr>
                    <th><FormattedMessage id="recyclingfeereports.numerus.reports.month"/></th>
                    <th><FormattedMessage id="recyclingfeereports.numerus.reports.val.fi"/></th>
                    <th><FormattedMessage id="recyclingfeereports.numerus.reports.val.al"/></th>
                    <th><FormattedMessage id="recyclingfeereports.numerus.reports.pomWeight.fi"/></th>
                    <th><FormattedMessage id="recyclingfeereports.numerus.reports.pomWeight.al"/></th>
                  </tr>
                </thead>
                <tbody className="reportData table table-bordered">
                  { getReportsDataTable() }
                </tbody>
              </table>
            </div>}

            { showReportsAlert &&
              <div className="alert-wrap">
                <Alert variant="warning" onClose={() => setShowReportsAlert(false)} dismissible={true}>
                  <FormattedMessage id="recyclingfeereports.numerus.reports.nodata" />
                </Alert>
              </div>
            }

          </Tab>
          <Tab eventKey="manualFetch" title={props.intl.formatMessage({id:'recyclingfeereports.numerus.manual'})}>

              <p className="tip">
                <FontAwesomeIcon className="tipIcon" icon={"info-circle" }/>
                <FormattedMessage id="recyclingfeereports.numerus.manual.tip"/>
              </p>
              <Row className="d-flex flex-row">
                <Col>
                  <Form.Group>
                    <label><FormattedMessage id="recyclingfeereports.numerus.month"/></label>
                    <DateSelector startPeriod={date} onChange={(value) => { setDate(value); clear(); } } dateFormat={'yyyy-MM'} />

                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="form-buttons d-flex flex-row">
                <button className="send-button btn btn-primary ml-auto"
                        onClick={() => {
                          clear();
                          fetchNumerusData();
                        }}
                        aria-label="fetch numerus">
                    <FormattedMessage id="recyclingfeereports.numerus.fetch"/>
                  </button>
                  <button
                    className="send-button btn btn-primary"
                    disabled={saveDisable}
                    onClick={() => {
                      if(!savedAlready) saveNumerusDataToDB(); else setConfirmationModalOpen(true);
                    }}
                  >
                    <FormattedMessage id="recyclingfeereports.numerus.save"/>
                  </button>
                </Col>
              </Row>

              { showAlert &&
                <div className="alert-wrap">
                  <Alert variant="warning" onClose={() => setShowAlert(false)} dismissible={true}>
                    <FormattedMessage id={alertTextKey} />
                  </Alert>
                </div>
              }

              { showInfo &&
                <div className="alert-wrap">
                  <Alert variant="warning" onClose={() => setShowInfo(false)} dismissible={true}>
                    <FormattedMessage id={infoTextKey} />
                    <hr />
                    <FormattedMessage id={infoTextMoreKey} />
                    <div>{ diffTotalValFi }</div>
                    <div>{ diffTotalValAl }</div>
                    <div>{ diffTotalPomFi }</div>
                    <div>{ diffTotalPomAl }</div>
                  </Alert>
                </div>
              }

              { numerusData &&
                <div className="search-results">
                  { getNumerusResultDataTable() }
                </div>
              }
          </Tab>
          <Tab eventKey="settings" title={props.intl.formatMessage({id:'recyclingfeereports.numerus.settings'})}>
            { tab === "settings" &&
            <>
              <p className="tip">
                <FontAwesomeIcon
                    className="tipIcon"
                    icon={"info-circle" }/>
                <FormattedMessage id="recyclingfeereports.manage.settings.tip"/>
              </p>
              <div className="d-flex flex-row row">
                <div className="col-md-6">
                  <Form.Group>
                    <label htmlFor="day-select"><FormattedMessage id="recyclingfeereports.manage.fetchday"/></label>
                    <select className="day-select form-control" id="day-select" value={scheduleData.dayOfMonth}
                      onChange={(e) => {
                        scheduleData.dayOfMonth = +e.target.value;
                        setScheduleData(scheduleData);
                        numerusAPI.saveRecyclingFeeSchedule(scheduleData).then(() => {
                        }).finally(() => {
                          setState({});
                        });
                      }}>
                      { getDayList() }
                    </select>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group>
                    <label htmlFor="time-select"><FormattedMessage id="recyclingfeereports.manage.fetchtime"/></label>
                    <select className="time-select form-control" id="time-select" value={localHour(scheduleData.hour)}
                      onChange={(e) => {
                        scheduleData.hour = utcHour(e.target.value);
                        setScheduleData(scheduleData);
                        numerusAPI.saveRecyclingFeeSchedule(scheduleData).then(() => {
                        }).finally(() => {
                          setState({});
                        });
                      }}>
                      { getTimeList() }
                    </select>
                  </Form.Group>
                </div>  
              </div>
            </>
            }
          </Tab>
        </Tabs>
      </div>

    </div>
  );
}

export default injectIntl(ManageRecyclingFeeReports);
